import { h, render } from 'preact';
import clsx from 'clsx';
import AutoPlayVideo from '../media/AutoPlayVideo';
import Image from '../utils/image';
import { useWindowSize } from '../utils/window-size';

export default (element, data) => {
  const init = () => {
    render(<FullWidth data={data} />, element);
  };

  // eslint-disable-next-line no-shadow
  const FullWidth = ({ data }) => {
    const { isTabletOrSmaller } = useWindowSize();
    const textColor = isTabletOrSmaller
      ? data?.mobile_text_color
      : data?.desktop_text_color;
    const backgroundColor = isTabletOrSmaller
      ? data?.mobile_text_background
      : data?.desktop_text_background;

    // eslint-disable-next-line consistent-return
    const renderCta = () => {
      if (data.cta_url && data.cta_label) {
        return (
          <div className="mt-4">
            <a
              href={data.cta_url}
              className="btn-primary-stroke link-unstyled inline-flex justify-center pt-[14.5px] pb-[14.5px]"
              style={{
                color: textColor,
                borderColor: textColor
              }}
            >
              {data.cta_label}
            </a>
          </div>
        );
      }
    };

    const desktopLayout = {
      left: 'left-10 max-w-[435px]',
      center: 'left-1/2 -translate-x-1/2 laptop:text-center max-w-[648px]',
      right: 'right-10 max-w-[435px]'
    }

    return (
      <div className={clsx('relative laptop:min-h-[700px] laptop:overflow-hidden', data.top_indent && 'laptop:pt-[57px]', data.bottom_indent && 'laptop:pb-[57px]')}>
        {data?.video_desktop ? (
          <AutoPlayVideo
            mobileVideo={data.video_mobile}
            desktopVideo={data.video_desktop}
            controls={data.controls}
            controlsPlacement={
              'top-2.5 laptop:top-auto laptop:bottom-5 justify-end'
            }
            classNames={
              'laptop:max-h-[1080px] laptop:object-cover laptop:object-center'
            }
          />
        ) : (
          <div className="laptop:overflow-hidden laptop:min-h-[700px] laptop:max-h-[1080px]">
            <div className="relative laptop:pt-[48.65%] pt-[67.8%] ">
              <Image
                classes={clsx('w-full h-full object-cover object-center absolute inset-0', data.image_bg_mobile && 'hidden laptop:block')}
                src={data.image_bg}
              />
              {data.image_bg_mobile &&
              <Image
                classes="w-full h-full object-cover object-center absolute inset-0 laptop:hidden"
                src={data.image_bg_mobile}
              />}
            </div>
          </div>
        )}
        <div
          className={clsx(
            data?.mobile_layout === 'overlay' && 'px-5',
            'bg-[#F9F7F3]',
          )}
        >
          <div
            className={clsx(
              'laptop:absolute w-full laptop:top-[50%] laptop:translate-y-[-50%] mx-auto',
              data?.mobile_layout === 'overlay' && 'translate-y-[-47px]',
              !isTabletOrSmaller &&
                (data?.desktop_layout && desktopLayout[data.desktop_layout]),
            )}
            style={{ backgroundColor }}
          >
            {data.image ? (
              <div className="relative laptop:pt-[60.5%] pt-[59.8%]">
                <Image
                  classes="w-full h-full object-cover object-center absolute inset-0"
                  src={data.image}
                />
              </div>
            ) : (
              ''
            )}
            <div
              className={clsx(
                data?.image
                  ? 'laptop:py-[30px] pb-[41px] py-[15px]'
                  : 'laptop:py-10 py-5',
                'laptop:px-10 px-5',
              )}
              style={{textAlign: data?.text_position}}
            >
              <p
                className="eyebrow mb-2 italic font-hoefler"
                style={{ color: textColor }}
              >
                {data.eyebrow}
              </p>
              <div
                className="rte rte__primary-headings leading-[42px] laptop:leading-[54px] laptop:mb-[10px] mb-[2px] break-words text-[32px] laptop:text-[44px] [&_p]:font-hoefler"
                style={{ color: textColor }}
                dangerouslySetInnerHTML={{ __html: data.title }}
              />
              <div
                className="font-14 leading-5 rte"
                style={{ color: textColor }}
                dangerouslySetInnerHTML={{ __html: data.description }}
              />
              {renderCta()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  init();
};
